/**
 * Map of category name -> map of item type name -> array of subtype names.
 */
export type AuctionsPlusItemTypeByCategory = Record<
  string,
  Record<string, string[]>
>;

/**
 * Map of manufacturer name -> array of model names.
 */
export type AuctionsPlusItemsByManufacturer = Record<string, string[]>;

declare global {
  interface Window {
    AuctionsPlusItemsByManufacturer?: AuctionsPlusItemsByManufacturer;
    AuctionsPlusItemTypeByCategory?: AuctionsPlusItemTypeByCategory;
  }
}

function getNodeAuctionsPlusItemTypeByCategory(): AuctionsPlusItemTypeByCategory {
  return {};
}

function getNodeAuctionsPlusItemsByManufacturer(): AuctionsPlusItemsByManufacturer {
  return {};
}

function getBrowserAuctionsPlusItemsByManufacturer(): AuctionsPlusItemsByManufacturer {
  return window.AuctionsPlusItemsByManufacturer || {};
}

function getBrowserAuctionsPlusItemTypeByCategory(): AuctionsPlusItemTypeByCategory {
  return window.AuctionsPlusItemTypeByCategory || {};
}

export function getAuctionsPlusItemTypeByCategory(): AuctionsPlusItemTypeByCategory {
  return typeof window === "undefined"
    ? getNodeAuctionsPlusItemTypeByCategory()
    : getBrowserAuctionsPlusItemTypeByCategory();
}

export function getAuctionsPlusItemsByManufacturer(): AuctionsPlusItemsByManufacturer {
  return typeof window === "undefined"
    ? getNodeAuctionsPlusItemsByManufacturer()
    : getBrowserAuctionsPlusItemsByManufacturer();
}
